import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import TuneIcon from '@material-ui/icons/Tune';
import { Form } from '@unform/web';
import { isEmpty, includes, isArray, isNull, isUndefined } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Spinner } from '~/components';
import {
  Input,
  Combobox,
  DateTime,
  Autocomplete,
  InputText,
  InputSlider,
  Checkbox,
} from '~/components/Form';
import { Select } from '~/components/Form/v2';
import {
  CENTRO_CUSTO_ABASTECIMENTO,
  MOTORISTA_ABASTECIMENTO,
  OPERACAO_ABASTECIMENTO,
  LOCALIDADE_ABASTECIMENTO,
  MODULO_20_GRAUS,
  TRR_CHILE,
  MODULO_FERROVIA,
  MODULO_CUSTOMIZACAO_VLI,
  CUSTOMIZACAO_RAIZEN,
  SAFRA_ABASTECIMENTO,
} from '~/constants/modules';
import { t, can, canURL, validCharacters } from '~/helpers';
import api from '~/services/api';
import {
  storeOperacaoAbastecimento,
  updateOperacaoAbastecimento,
} from '~/store/modules/operacaoabastecimento/actions';

export default function CreateOrUpdate({
  reference,
  data,
  create,
  toggleLoading,
  toggleConfirmButton,
}) {
  const dispatch = useDispatch();

  const permission = canURL();

  const [habCodigoVeiculo, setHabCodigoVeiculo] = useState(true);
  const [habCodigoCentroCusto, setHabCodigoCentroCusto] = useState(true);
  const [habTotalizador, setHabTotalizador] = useState(true);
  const [habTotalizador2, setHabTotalizador2] = useState(true);
  const [habMotorista, setHabMotorista] = useState(true);
  const [habCodigoUsuario, setHabCodigoUsuario] = useState(true);
  const [loadingScreen, setLoading] = useState(false);
  const [pendingRequests, setPendingRequests] = useState(0);
  const [hasLoadingError, setHasLoadingError] = useState(false);
  const loadingErrorMessage = 's.geral.loadingerror';
  const [habTrocaParaEmpresaAtual, setHabTrocaParaEmpresaAtual] = useState(
    false
  );
  const [isSafraHabilitado, setIsSafraHabilitado] = useState(false);

  const [habPercentualTanqueFinal, setHabPercentualTanqueFinal] = useState(
    true
  );

  const [posto, setPosto] = useState(0);
  const [localidadeFixa, setLocalidadeFixa] = useState(null);
  const [submittedData, setSubmittedData] = useState({});
  const [veiculo, setVeiculo] = useState(null);
  const [custo, setCusto] = useState(null);
  const [motorista, setMotorista] = useState(null);
  const [totalizador, setTotalizador] = useState(0);
  const [totalizador2, setTotalizador2] = useState(0);
  const [empresaVeiculo, setEmpresaveiculo] = useState(null);
  const [optionsOper, setOptionsOper] = useState([]);

  const [empresaAtualNomeVeiculo, setEmpresaAtualNomeVeiculo] = useState(null);
  const [empresaAtualCodigoVeiculo, setEmpresaAtualCodigoVeiculo] = useState(
    null
  );
  const [trocaparaempresaatual, setTrocaparaempresaatual] = useState(false);

  const [tipoveiculoBase, setTipoveiculoBase] = useState(null);
  const [tipoauxiliarveiculoBase, setTipoauxiliarveiculoBase] = useState(null);
  const [exibeCampoMotorista, setExibeCampoMotorista] = useState(false);

  const { client } = useSelector((state) => state.user.profile);
  const { internounidatausuario, formaidfrentistaabast } = useSelector(
    (state) => state.user.configs
  );

  const [veiculoOld, setVeiculoOld] = useState(null);

  const [idEmpresaOld, setIdEmpresaOld] = useState(null);
  // const [idEmpresa, setIdEmpresa] = useState(null);

  const [temperaturamedia, setTemperaturamedia] = useState(0.0);
  const [controla20graus, setControla20graus] = useState(0);
  const [operabastecimento20posto, setOperabastecimento20posto] = useState(0);

  const [densidade20, setDensidade20] = useState(0);
  const [volume20, setVolume20] = useState(0);

  const [exibemotoristaterminal, setExibemotoristaterminal] = useState(0);
  const [
    diasliberadigitacaomovimentacaobico,
    setDiasliberadigitacaomovimentacaobico,
  ] = useState(0);

  const [
    exibemotoristaempresaveiculoLocal,
    setExibemotoristaempresaveiculoLocal,
  ] = useState(0);

  const { loading, find, params } = useSelector(
    (state) => state.operacaoabastecimento
  );

  const initials = create ? data : { ...find, ...data };
  const formInitials = create ? { ...initials, ...submittedData } : initials;

  const handleAsyncLoadingChange = useCallback(
    (isLoading) => {
      setPendingRequests((state) => {
        if (hasLoadingError) return 0;

        if (isLoading) return state + 1;

        return state > 0 ? state - 1 : 0;
      });
    },
    [hasLoadingError]
  );

  const handleAsyncLoadingError = useCallback(() => {
    setHasLoadingError(true);
    setPendingRequests(0);
  }, []);

  const handleTrackApiRequest = useCallback(
    async (request) => {
      handleAsyncLoadingChange(true);

      try {
        return await request();
      } catch (error) {
        handleAsyncLoadingError();
        throw error;
      } finally {
        handleAsyncLoadingChange(false);
      }
    },
    [handleAsyncLoadingChange, handleAsyncLoadingError]
  );

  const handleGetAPIModel = useCallback(
    async (id) => {
      try {
        const response = await handleTrackApiRequest(() =>
          api.get(`/modeloveiculooperacao/operacoes/${id}`, {
            params: { pesquisalista: true },
          })
        );

        setOptionsOper(
          response.data.map((i) => ({
            label: i.descricaooperacao,
            value: i.idoperacao,
          }))
        );
      } catch (err) {
        setOptionsOper([]);
      }
    },
    [handleTrackApiRequest]
  );

  const handleGetAPIVehicle = useCallback(
    async (id) => {
      try {
        const response = await handleTrackApiRequest(() =>
          api.get('veiculos', {
            params: {
              wherefield: 'idveiculo',
              typewherefield: 'EQUALS',
              valuewherefield: id,
              pesquisalista: true,
            },
          })
        );

        const { idmodeloveiculo } = response.data.items.shift();

        await handleGetAPIModel(idmodeloveiculo);
      } catch (err) {
        setOptionsOper([]);
      }
    },
    [handleGetAPIModel, handleTrackApiRequest]
  );

  async function handleGetVeiculo(idveiculo, empresaveiculo = undefined) {
    if (idveiculo) {
      try {
        const response = await handleTrackApiRequest(() =>
          api.get('veiculos', {
            params: {
              filterveic: 'false',
              wherefield: 'idveiculo',
              typewherefield: 'EQUALS',
              valuewherefield: idveiculo,
              pesquisalista: true,
            },
          })
        );

        if (!isEmpty(response.data) && !isEmpty(response.data.items)) {
          reference.current !== null &&
            reference.current.setFieldValue('idveiculo', idveiculo);

          const {
            idempresaveiculo,
            nomeempresaveiculo,
            tipototalizadorveiculo,
            tipototalizador2veiculo,
            idcentrocusto,
            idmodeloveiculo,
            statusveiculo,
            tipoveiculo,
            tipoauxiliarveiculo,
            exibemotoristaempresaveiculo,
          } = response.data.items[0];

          const nomeEmpresaAtual = nomeempresaveiculo;

          setEmpresaAtualCodigoVeiculo(idempresaveiculo);
          setEmpresaAtualNomeVeiculo(nomeempresaveiculo);

          setTipoveiculoBase(tipoveiculo);
          setTipoauxiliarveiculoBase(tipoauxiliarveiculo);

          // console.log(JSON.stringify(response.data.items[0]))

          if (reference.current !== null) {
            if (statusveiculo !== 'L') {
              if (create) {
                reference.current.setFieldError(
                  'idveiculo',
                  'Veículo está Bloqueado ou Cancelado!'
                );
                setEmpresaveiculo('');
                reference.current.setFieldValue('idempresaveiculo', null);
                return;
              }
              if (veiculoOld) {
                if (veiculoOld !== idveiculo) {
                  reference.current.setFieldError(
                    'idveiculo',
                    'Veículo está Bloqueado ou Cancelado!'
                  );
                  setEmpresaveiculo('');
                  reference.current.setFieldValue('idempresaveiculo', null);
                  return;
                }
              }
            }
          }

          reference.current !== null &&
            reference.current.setFieldValue('idveiculo', idveiculo);

          // DAGNO TESTE 30/01/2024
          if (create || (!isNull(veiculoOld) && veiculoOld !== idveiculo)) {
            setExibemotoristaempresaveiculoLocal(
              Number(exibemotoristaempresaveiculo) || 0
            );

            if (!can(CUSTOMIZACAO_RAIZEN)) {
              setEmpresaveiculo(nomeempresaveiculo);
            } else {
              setEmpresaveiculo(idempresaveiculo);
            }

            setTotalizador(Number(tipototalizadorveiculo) || 0);
            setTotalizador2(Number(tipototalizador2veiculo) || 0);
            await handleGetAPIModel(idmodeloveiculo);
            reference.current !== null &&
              reference.current.setFieldValue(
                'idempresaveiculo',
                idempresaveiculo
              );
          } else {
            setTotalizador(Number(tipototalizadorveiculo) || 0);
            setTotalizador2(Number(tipototalizador2veiculo) || 0);

            await handleGetAPIModel(idmodeloveiculo);

            const responseEmpresa = await handleTrackApiRequest(() =>
              api.get('empresasveiculos', {
                params: {
                  filterveic: 'false',
                  wherefield: 'idempresaveiculo',
                  typewherefield: 'EQUALS',
                  valuewherefield: !isUndefined(empresaveiculo)
                    ? empresaveiculo
                    : idempresaveiculo,
                  pesquisalista: true,
                },
              })
            );

            // const { nomeempresaveiculo } = responseEmpresa.data.items[0];
            const nomeempresaveiculonova =
              responseEmpresa?.data?.items?.[0]?.nomeempresaveiculo ?? '';

            const exibemotorista =
              responseEmpresa?.data?.items?.[0]?.exibemotoristaempresaveiculo ??
              0;

            setExibemotoristaempresaveiculoLocal(exibemotorista);

            if (nomeempresaveiculonova) {
              if (!can(CUSTOMIZACAO_RAIZEN)) {
                setEmpresaveiculo(nomeempresaveiculo);
              } else {
                setEmpresaveiculo(idempresaveiculo);
              }
            } else {
              setEmpresaveiculo(idempresaveiculo);
            }

            if (!create && permission.altera_empresa === true) {
              if (nomeempresaveiculonova) {
                if (nomeEmpresaAtual !== nomeempresaveiculonova) {
                  setHabTrocaParaEmpresaAtual(permission.altera_empresa);
                }
              }
            }
          }

          // setEmpresaveiculo(nomeempresaveiculo);
          // setTotalizador(Number(tipototalizadorveiculo) || 0);
          // handleGetAPIModel(idmodeloveiculo);
          // reference.current !== null &&  reference.current.setFieldValue('idempresaveiculo', idempresaveiculo);

          if (can(CENTRO_CUSTO_ABASTECIMENTO) && !isEmpty(idcentrocusto)) {
            if (!create) {
              if (String(find.idveiculo) !== String(idveiculo)) {
                reference.current !== null &&
                  reference.current.setFieldValue(
                    'idcentrocusto',
                    idcentrocusto
                  );
                setCusto(idcentrocusto);
              } else if (!isEmpty(find.idcentrocusto)) {
                reference.current !== null &&
                  reference.current.setFieldValue(
                    'idcentrocusto',
                    find.idcentrocusto
                  );
                setCusto(find.idcentrocusto);
              }
            } else {
              reference.current !== null &&
                reference.current.setFieldValue('idcentrocusto', idcentrocusto);
              setCusto(idcentrocusto);
            }
          }
        } else {
          reference.current !== null &&
            reference.current.setFieldError(
              'idveiculo',
              !can(TRR_CHILE)
                ? 'Veículo não encontrado!'
                : 'Cliente não encontrado!'
            );
        }
      } catch (err) {
        setOptionsOper([]);
      }
    }
  }

  async function handleValidateCenterCost(e) {
    const cc = e.target.value;

    if (cc) {
      setCusto(e.target.value);
      if (cc !== '') {
        const response = await api
          .get(`centroscustos/${cc}`, { params: { pesquisalista: true } })
          .catch(async () => {
            reference.current !== null &&
              reference.current.setFieldValue('idcentrocusto', null);
            setCusto('');
            reference.current !== null &&
              reference.current.setFieldError(
                'idcentrocusto',
                'Centro de Custo não encontrado!'
              );
          });

        if (response && !isEmpty(response.data)) {
          const { idcentrocusto } = response.data;
          reference.current !== null &&
            reference.current.setFieldValue('idcentrocusto', idcentrocusto);
          setCusto(idcentrocusto);
        } else {
          reference.current !== null &&
            reference.current.setFieldValue('idcentrocusto', null);
          setCusto('');
        }
      } else {
        setCusto(e.target.value);
      }
    }
  }

  async function handleValidateMotorista() {
    await api
      .get(`motoristas/${motorista}`, { params: { pesquisalista: true } })
      .catch(async () => {
        reference.current !== null &&
          reference.current.setFieldValue('idmotorista', null);
        setCusto('');

        reference.current !== null &&
          reference.current.setFieldError(
            'idmotorista',
            'Motorista não encontrado!'
          );
      });
  }

  const handleGetListaSafra = useCallback(async () => {
    try {
      const response = await handleTrackApiRequest(() =>
        api.get(`/safras`, {
          params: {
            pagesize: 99999,
            wherefield: '',
            typewherefield: '',
            valuewherefield: '',
            // orderfield: '',
            pesquisalista: true,
          },
        })
      );
      if (response.data.items.length <= 0) {
        setIsSafraHabilitado(false);
      } else {
        setIsSafraHabilitado(true);
      }
      // setOptionsSafra(
      //   response.data.items.map((i) => ({
      //     label: i.descricaosafra,
      //     value: i.idsafra,
      //   }))
      // );
    } catch (err) {
      setIsSafraHabilitado(false);
    }
  }, [handleTrackApiRequest]);

  const handleTestVeiculoLiberado = useCallback(async () => {
    try {
      const response = await api.get('veiculos', {
        params: {
          filterveic: 'false',
          wherefield: 'idveiculo',
          typewherefield: 'EQUALS',
          valuewherefield: veiculo,
          pesquisalista: true,
        },
      });
      if (!isEmpty(response.data) && !isEmpty(response.data.items)) {
        const { statusveiculo } = response.data.items[0];
        if (statusveiculo !== 'L') {
          if (create) {
            return false;
          }
          if (veiculoOld) {
            if (veiculoOld !== veiculo) {
              return false;
            }
          }
        }
      }
      return true;
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    } finally {
      setLoading(false);
    }
  }, [veiculo, veiculoOld, initials]);

  async function handleSubmit(param) {
    try {
      setLoading(true);
      if (hasLoadingError) {
        toast.error(t(loadingErrorMessage));
        return;
      }

      if (pendingRequests > 0) {
        toast.warning(t('s.geral.validacao.aguardecarregamento'));
        return;
      }

      if (create) {
        setSubmittedData(param);
      }

      const schema = Yup.object().shape({
        idposto: Yup.string()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .required(t('s.geral.validacao.campoobrigatorio')),
        idbico: Yup.string().required(t('s.geral.validacao.campoobrigatorio')),

        datahorainicialmovimentacao: create
          ? Yup.string()
            .test(
              'campo-existe',
              t('s.geral.validacao.campoobrigatorio').replace(
                '%s',
                'datahorainicialmovimentacao'
              ),
              function (value) {
                const data = this.parent;

                if (!('datahorainicialmovimentacao' in data)) {
                  const msg = `(Data hora inicial) - ${t(
                    's.geral.validacao.campoobrigatorio'
                  ).replace('%s', 'datahorainicialmovimentacao')}`;
                  toast.error(msg);
                  return this.createError({ message: msg });
                }

                return true;
              }
            )
            .required(t('s.geral.validacao.campoobrigatorio'))
            .test(
              'min-date',
              t('s.geral.validacao.data_minima').replace(
                '%s',
                diasliberadigitacaomovimentacaobico
              ),
              (value) => {
                if (!value) return true; // já tratado pelo required
                const date = moment(value, 'DD/MM/YYYY HH:mm:ss');
                return (
                  date.isValid() &&
                  date.isSameOrAfter(
                    moment().subtract(
                      diasliberadigitacaomovimentacaobico,
                      'days'
                    )
                  )
                );
              }
            )
            .test('max-date', t('s.geral.validacao.data_maxima'), (value) => {
              if (!value) return true;
              const date = moment(value, 'DD/MM/YYYY HH:mm:ss');
              return date.isValid() && date.isSameOrBefore(moment());
            })
          : Yup.string().required(t('s.geral.validacao.campoobrigatorio')),
        datahorafinalmovimentacao: create
          ? Yup.string()
            .test(
              'campo-existe',
              t('s.geral.validacao.campoobrigatorio').replace(
                '%s',
                'datahorafinalmovimentacao'
              ),
              function (value) {
                const data = this.parent;

                if (!('datahorafinalmovimentacao' in data)) {
                  const msg = `(Data hora final) - ${t(
                    's.geral.validacao.campoobrigatorio'
                  ).replace('%s', 'datahorafinalmovimentacao')}`;
                  toast.error(msg);
                  return this.createError({ message: msg });
                }

                return true;
              }
            )
            .required(t('s.geral.validacao.campoobrigatorio'))
            .test(
              'after-inicial',
              t('s.geral.validacao.data_final_maior_inicial'),
              function (value) {
                const { datahorainicialmovimentacao } = this.parent;
                if (!value || !datahorainicialmovimentacao) return true;
                const start = moment(
                  datahorainicialmovimentacao,
                  'DD/MM/YYYY HH:mm:ss'
                );
                const end = moment(value, 'DD/MM/YYYY HH:mm:ss');
                return end.isValid() && end.isSameOrAfter(start);
              }
            )
            .test(
              'not-future',
              t('s.geral.validacao.data_final_maior_hoje'),
              (value) => {
                if (!value) return true;
                const end = moment(value, 'DD/MM/YYYY HH:mm:ss');
                return end.isValid() && end.isSameOrBefore(moment()); // não permite data futura
              }
            )
          : Yup.string().required(t('s.geral.validacao.campoobrigatorio')),

        // datahorainicialmovimentacao: Yup.string().required(
        //   t('s.geral.validacao.campoobrigatorio')
        // ),
        // datahorafinalmovimentacao: Yup.string().required(
        //   t('s.geral.validacao.campoobrigatorio')
        // ),
        idveiculo: Yup.string()
          .trim()
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .required(t('s.geral.validacao.campoobrigatorio'))
          .min(1, t('s.geral.validacao.campoobrigatorio'))
          .test(
            'characters-invalid',
            t('s.configuracao.geral.naopodecontercaracterespecial'),
            (value) => validCharacters(value)
          )
          .test(
            t('s.operacao.abastecimento.veiculobloqueadocancelado'),
            t('s.operacao.abastecimento.veiculobloqueadocancelado'),
            (veiculo) => handleTestVeiculoLiberado(veiculo)
          ),
        totalizadormovimentacaoabastecimento: includes([1, 2], totalizador)
          ? Yup.number()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio'))
          : Yup.string().nullable(),
        totalizador2movimentacaoabastecimento:
          totalizador2 && includes([1, 2], totalizador2)
            ? Yup.number()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string().nullable(),
        encerranteinicialmovimentacao: Yup.number().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        encerrantefinalmovimentacao: Yup.number().required(
          t('s.geral.validacao.campoobrigatorio')
        ),
        volumemovimentacao: Yup.number()
          .required(t('s.geral.validacao.campoobrigatorio'))
          .typeError(t('s.geral.validacao.campoobrigatorio'))
          .test(
            'encerrantes-volume',
            t('s.geral.validacao.valorvolumediferencaencerrantes'),
            function validateEncerrantesVolume(value) {
              const {
                encerranteinicialmovimentacao,
                encerrantefinalmovimentacao,
              } = this.parent;

              if (
                value === undefined ||
                encerranteinicialmovimentacao === undefined ||
                encerrantefinalmovimentacao === undefined
              ) {
                return true;
              }

              return (
                Math.abs(
                  Number(value) -
                    (Number(encerrantefinalmovimentacao) -
                      Number(encerranteinicialmovimentacao))
                ) <= 0.1
              );
            }
          ),
        codigousuario:
          formaidfrentistaabast !== 0
            ? Yup.string()
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .test(
                'characters-invalid',
                t('s.configuracao.geral.naopodecontercaracterespecial'),
                (value) => validCharacters(value)
              )
              .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string().nullable(),
        idoperacao:
          can(OPERACAO_ABASTECIMENTO) && !isEmpty(optionsOper)
            ? Yup.string()
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string(),

        idmotorista:
          (!can(CUSTOMIZACAO_RAIZEN) &&
            can(MOTORISTA_ABASTECIMENTO) &&
            habMotorista) ||
            (can(CUSTOMIZACAO_RAIZEN) &&
              can(MOTORISTA_ABASTECIMENTO) &&
              habMotorista &&
              exibeCampoMotorista)
            ? Yup.string()
              .typeError(t('s.geral.validacao.campoobrigatorio'))
              .required(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string().nullable(),
        // idmotorista:
        //   can(MOTORISTA_ABASTECIMENTO) && habMotorista && exibemotoristaterminal > 0
        //     ? Yup.string()
        //       .typeError(t('s.geral.validacao.campoobrigatorio'))
        //       .required(t('s.geral.validacao.campoobrigatorio'))
        //     : Yup.string().nullable(),

        idcentrocusto: can(CENTRO_CUSTO_ABASTECIMENTO)
          ? Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .min(1, t('s.geral.validacao.campoobrigatorio'))
            .nullable()
          : Yup.string(),

        idlocalidade: can(LOCALIDADE_ABASTECIMENTO)
          ? Yup.number()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .typeError(t('s.geral.validacao.campoobrigatorio'))
          : Yup.string(),

        idsafra:
          can(SAFRA_ABASTECIMENTO) && isSafraHabilitado
            ? Yup.number()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string(),

        percentualtanquemovimentacaoabastecimento:
          can(MODULO_FERROVIA) && can(MODULO_CUSTOMIZACAO_VLI)
            ? Yup.number()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .typeError(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string(),

        temperaturamediamovimentacao:
          can(MODULO_20_GRAUS) && controla20graus && operabastecimento20posto
            ? Yup.number()
              .required(t('s.geral.validacao.campoobrigatorio'))
              .transform((value) => (isNaN(value) ? undefined : value))
              // .integer(t('s.geral.validacao.deveserinteiro'))
              .moreThan(
                -1,
                t('s.geral.validacao.valorminimo').replace('%s', 0)
              )
              .lessThan(
                101,
                t('s.geral.validacao.valormaximo').replace('%s', 100)
              )
              .typeError(t('s.geral.validacao.campoobrigatorio'))
            : Yup.string(),
      });

      let objParam = { ...param };

      if (can(MODULO_20_GRAUS) && controla20graus && operabastecimento20posto) {
        let { temperaturamediamovimentacao } = param;
        if (temperaturamediamovimentacao) {
          temperaturamediamovimentacao = String(
            temperaturamediamovimentacao
          ).replace(',', '.');
        }

        objParam = {
          ...param,
          temperaturamediamovimentacao,
        };
      }

      await schema.validate(objParam, {
        abortEarly: false,
      });

      const {
        datahorainicialmovimentacao,
        datahorafinalmovimentacao,
      } = objParam;
      const allData = reference.current.getData();

      let objSend = {
        volumepredeterminadomovimentacao: '100',
        modomovimentacao: '0',
        formaidmovimentacao: '0',
        idmovimentacao: '0',
        tipomovimentacao: '0',
        numerologmovimentacao: '0',
        onlinemovimentacao: '0',
        precounitariomovimentacao: '0.0',
        vazaomediamovimentacao: '0.0',
        vazaomaximamovimentacao: '0.0',
        idcentrocusto: '',
        idcontrato: '',

        codigousuario: '',

        totalizadoranteriormovimentacaoabastecimento: '0.0',
        totalizador2anteriormovimentacaoabastecimento: '0.0',
        totalizadorconfirmadomovimentacaoabastecimento: '0.0',
        contingenciamovimentacaoabastecimento: '0',
        ...initials,
        ...allData,

        codigousuario: allData.codigousuario ?? initials.codigousuario,
        idoperacao: allData.idoperacao ?? initials.idoperacao,
        totalizadormovimentacaoabastecimento:
          allData.totalizadormovimentacaoabastecimento ??
          initials.totalizadormovimentacaoabastecimento,
        totalizador2movimentacaoabastecimento:
          allData.totalizador2movimentacaoabastecimento ??
          initials.totalizador2movimentacaoabastecimento,
        datahorainicialmovimentacao,
        datahorafinalmovimentacao,
        idcliente: client,

        densidade20movimentacao: 0.0,
        volume20movimentacao: 0.0,
        temperaturamediamovimentacao: 0.0,

        idveiculo: veiculo,
      };

      if (can(LOCALIDADE_ABASTECIMENTO)) {
        objSend = { ...objSend, idlocalidade: objParam.idlocalidade };
      }

      if (create) {
        setSubmittedData(objSend);
      }

      if (can(MODULO_20_GRAUS) && controla20graus && operabastecimento20posto) {
        objSend = {
          ...objSend,
          temperaturamediamovimentacao: objParam.temperaturamediamovimentacao,
          densidade20movimentacao: create
            ? 0.0
            : objParam.densidade20movimentacao,
          volume20movimentacao: create ? 0.0 : objParam.volume20movimentacao,
        };
      }

      if (trocaparaempresaatual) {
        if (!create && canURL().altera_empresa) {
          objSend = {
            ...objSend,
            idempresaveiculo:
              empresaAtualCodigoVeiculo || objParam.idempresaveiculo,
          };
        }
      }

      // Veriricar se necessário depois o backend deve ser alterado para permitir isso
      // if (can(CUSTOMIZACAO_RAIZEN) && can(MOTORISTA_ABASTECIMENTO) && !exibeCampoMotorista) {
      //   objSend = { ...objSend, idmotorista: null };
      // }

      if (create) {
        dispatch(storeOperacaoAbastecimento(objSend, params));
      } else {
        dispatch(updateOperacaoAbastecimento(objSend, params));
      }
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        reference.current.setErrors(validationErrors);
      }
    } finally {
      setLoading(false);
    }
  }

  const handleValidateInputVehicle = useCallback(async () => {
    await reference.current.setFieldValue('idoperacao', '');

    if (veiculo) {
      await handleGetVeiculo(veiculo, idEmpresaOld);
    }
  }, [veiculo, veiculoOld, idEmpresaOld, canURL]);

  function atualizarExibeCampoMotorista({
    exibemotoristaterminal,
    tipoveiculoBase,
    exibemotoristaempresaveiculoLocal,
    create,
    setExibeCampoMotorista,
  }) {
    switch (exibemotoristaterminal ?? 0) {
      case 0:
        setExibeCampoMotorista(false);
        break;
      case 1:
      case 2:
        setExibeCampoMotorista(true);
        break;
      case 3:
      case 4:
        setExibeCampoMotorista(tipoveiculoBase === 0);
        break;
      case 5:
      case 6:
        setExibeCampoMotorista(tipoveiculoBase === 1);
        break;
      case 7:
      case 8:
        setExibeCampoMotorista(exibemotoristaempresaveiculoLocal > 0);
        break;
      default:
        if (!create) {
          setExibeCampoMotorista(false);
        }
    }
  }

  useEffect(() => {
    if (loading) return;

    // Define flags auxiliares
    const podeAlterarTotalizador =
      internounidatausuario === 'S' || canURL().altera_totalizador;

    // Atualiza veículo inicial, se necessário
    if (!create && veiculo) {
      initials.idveiculo = veiculo;
    }

    const formId = initials.formaidmovimentacao ?? 0;

    // --- Configuração de habilitações principais ---
    const habilitacoes = {
      codigoVeiculo: false,
      codigoCentroCusto: false,
      totalizador: false,
      totalizador2: false,
      codigoUsuario: false,
      percentualTanqueFinal: false,
    };

    const setHabilitacoes = (vals) => {
      setHabCodigoVeiculo(vals.codigoVeiculo);
      setHabCodigoCentroCusto(vals.codigoCentroCusto);
      setHabTotalizador(vals.totalizador);
      setHabTotalizador2(vals.totalizador2);
      setHabCodigoUsuario(vals.codigoUsuario);
      setHabPercentualTanqueFinal(vals.percentualTanqueFinal);
    };

    switch (formId) {
      case 0:
      case 106:
        setHabilitacoes({
          codigoVeiculo: true,
          codigoCentroCusto: true,
          totalizador: true,
          totalizador2: true,
          codigoUsuario: true,
          percentualTanqueFinal: true,
        });
        break;

      case 1:
      case 4:
      case 8:
        setHabilitacoes({
          codigoVeiculo: podeAlterarTotalizador,
          codigoCentroCusto: true,
          totalizador: true,
          totalizador2: true,
          codigoUsuario: false,
          percentualTanqueFinal: true,
        });
        break;

      case 3:
      case 2:
      case 6:
      case 10:
        setHabilitacoes({
          codigoVeiculo: podeAlterarTotalizador,
          codigoCentroCusto: true,
          totalizador: podeAlterarTotalizador,
          totalizador2: podeAlterarTotalizador,
          codigoUsuario: false,
          percentualTanqueFinal: internounidatausuario === 'S',
        });
        break;

      default:
        if (!create) {
          setHabilitacoes({
            codigoVeiculo: podeAlterarTotalizador,
            codigoCentroCusto: false,
            totalizador: podeAlterarTotalizador,
            totalizador2: podeAlterarTotalizador,
            codigoUsuario: false,
            percentualTanqueFinal: internounidatausuario === 'S',
          });
        }
    }

    // --- Configuração do motorista ---
    const atualizarMotorista = () => {
      const exibeMotorista = (exibe) => {
        setHabMotorista(exibe);
        setExibeCampoMotorista(exibe);
      };

      const exibeMotoristaTerminal = exibemotoristaterminal ?? 0;

      const deveExibirPorTipo = (tipo) =>
        (tipo === 0 && tipoveiculoBase === 0) ||
        (tipo === 1 && tipoveiculoBase === 1);

      switch (exibeMotoristaTerminal) {
        case 0:
          exibeMotorista(false);
          break;
        case 1:
        case 2:
          exibeMotorista(true);
          break;
        case 3:
        case 4:
          exibeMotorista(deveExibirPorTipo(0));
          break;
        case 5:
        case 6:
          exibeMotorista(deveExibirPorTipo(1));
          break;
        case 7:
        case 8:
          exibeMotorista(exibemotoristaempresaveiculoLocal > 0);
          break;
        default:
          if (!create) exibeMotorista(false);
      }
    };

    if (!create && !loading) {
      atualizarMotorista();
    } else if (can(MOTORISTA_ABASTECIMENTO)) {
      atualizarMotorista();
    }
  }, [
    loading,
    create,
    veiculo,
    initials,
    internounidatausuario,
    exibemotoristaterminal,
    tipoveiculoBase,
    exibemotoristaempresaveiculoLocal,
  ]);

  useEffect(() => {
    let mounted = true;
    if (mounted && !isEmpty(find)) {
      const {
        encerranteinicialmovimentacao,
        encerrantefinalmovimentacao,
        idveiculo,

        idempresaveiculo,

        idposto,
      } = find;
      if (!create) {
        setPosto(idposto);

        if (idempresaveiculo) {
          // setIdEmpresa(idempresaveiculo || 0);
          setIdEmpresaOld(idempresaveiculo || 0);
        }

        if (idveiculo) {
          setVeiculoOld(idveiculo || 0);
          setVeiculo(idveiculo || 0);
          handleGetVeiculo(idveiculo, idempresaveiculo);
        }
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [find]);

  useEffect(() => {
    if (!create && !isEmpty(find)) handleGetAPIVehicle(find.idveiculo);
  }, [create, find]);

  useEffect(() => {
    if (can(SAFRA_ABASTECIMENTO)) {
      handleGetListaSafra();
    }
  }, [handleGetListaSafra]);

  useEffect(() => {
    toggleLoading(pendingRequests > 0);
  }, [pendingRequests, toggleLoading]);

  useEffect(() => {
    toggleConfirmButton(!hasLoadingError);
  }, [hasLoadingError, toggleConfirmButton]);

  useEffect(
    () => () => {
      toggleLoading(false);
      toggleConfirmButton(true);
    },
    [toggleLoading, toggleConfirmButton]
  );

  const handleChangepostoscomboios = React.useCallback((value) => {
    if (value.idposto) {
      setPosto(value.idposto);
      setLocalidadeFixa(
        Number(value.idlocalidade) > 0 ? Number(value.idlocalidade) : null
      );
      setControla20graus(value.controla20grausposto);
      setOperabastecimento20posto(value.operabastecimento20posto);
    } else {
      setLocalidadeFixa(null);
      setControla20graus(0);
      setOperabastecimento20posto(0);
      // novo
      setPosto(null);
    }
    // setDiasliberadigitacaomovimentacaobico(-2)
  }, []);

  return (
    <>
      {loading || loadingScreen ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : hasLoadingError ? (
        <div
          style={{
            border: '1px solid #f5c6cb',
            background: '#f8d7da',
            color: '#721c24',
            borderRadius: '4px',
            padding: '16px',
            lineHeight: 1.5,
          }}
        >
          {t(loadingErrorMessage)}
        </div>
      ) : (
        <div style={{ position: 'relative', minHeight: '14rem' }}>
          <Form
            ref={reference}
            initialData={formInitials}
            onSubmit={handleSubmit}
          >
            {/* <h1>{JSON.stringify(initials.idempresaveiculo)}</h1>
          <h1>{JSON.stringify(isNull(reference.current) ? '' : reference.current.getData().idempresaveiculo)}</h1> */}
            {/* <h1>{JSON.stringify(diasliberadigitacaomovimentacaobico)}</h1> */}
            <Autocomplete
              name="idposto"
              disabled={!create}
              disableClearable={!create}
              label="codigonomeposto"
              url="postoscomboios"
              unique="idposto"
              title={t('s.menu.configuracao.posto')}
              getValue={(value) => {
                handleChangepostoscomboios(value);
                // if (value.idposto) {
                //   setPosto(value.idposto);
                //   setControla20graus(value.controla20grausposto);
                //   setOperabastecimento20posto(value.operabastecimento20posto);
                // } else {
                //   setControla20graus(0);
                //   setOperabastecimento20posto(0);
                //   //novo
                //   setPosto(null);
                // }
                // if (!isNull(reference.current)) {
                //   reference.current.setFieldValue("idbico", null);
                // }
                // setDiasliberadigitacaomovimentacaobico(-2)
                // console.log(JSON.stringify(value))
              }}
              onLoadingChange={handleAsyncLoadingChange}
              onLoadingError={handleAsyncLoadingError}
            />

            {create ? (
              posto ? (
                <Combobox
                  name="idbico"
                  disabled={!create || posto === 0}
                  label="bicoprodutobico"
                  url="bicos"
                  unique="idbico"
                  title={t('s.menu.configuracao.bico')}
                  hiddens={[{ name: 'idterminal' }, { name: 'idproduto' }]}
                  params={{
                    wherefield: !create
                      ? ['idposto', 'tipoproduto']
                      : [
                        'idposto',
                        'tipoproduto',
                        'bloqueiadigitacaomovimentacaobico',
                      ],
                    valuewherefield: !create
                      ? [posto ?? find.idposto, 'C']
                      : [posto ?? find.idposto, 'C', 'S'],
                    typewherefield: !create
                      ? ['EQUALS', 'EQUALS']
                      : ['EQUALS', 'EQUALS', 'EQUALS'],
                    fieldlist:
                      'idbico, idterminal, idproduto, bicoprodutobico, exibemotoristaterminal, diasliberadigitacaomovimentacaobico',
                  }}
                  getValue={(value) => {
                    if (value?.exibemotoristaterminal) {
                      setExibemotoristaterminal(value?.exibemotoristaterminal);
                    } else {
                      setExibemotoristaterminal(0);
                    }
                    if (value?.diasliberadigitacaomovimentacaobico) {
                      setDiasliberadigitacaomovimentacaobico(
                        value?.diasliberadigitacaomovimentacaobico
                      );
                    } else {
                      setDiasliberadigitacaomovimentacaobico(-1);
                    }

                    // console.log(JSON.stringify(value))
                  }}
                  onLoadingChange={handleAsyncLoadingChange}
                  onLoadingError={handleAsyncLoadingError}
                />
              ) : (
                <></>
              )
            ) : (
              <Combobox
                name="idbico"
                disabled={!create || posto === 0}
                label="bicoprodutobico"
                url="bicos"
                unique="idbico"
                title={t('s.menu.configuracao.bico')}
                hiddens={[{ name: 'idterminal' }, { name: 'idproduto' }]}
                params={{
                  wherefield: !create
                    ? ['idposto', 'tipoproduto']
                    : [
                      'idposto',
                      'tipoproduto',
                      'bloqueiadigitacaomovimentacaobico',
                    ],
                  valuewherefield: !create
                    ? [posto ?? find.idposto, 'C']
                    : [posto ?? find.idposto, 'C', 'S'],
                  typewherefield: !create
                    ? ['EQUALS', 'EQUALS']
                    : ['EQUALS', 'EQUALS', 'EQUALS'],
                  fieldlist:
                    'idbico, idterminal, idproduto, bicoprodutobico, exibemotoristaterminal, diasliberadigitacaomovimentacaobico',
                }}
                getValue={(value) => {
                  if (value?.exibemotoristaterminal) {
                    setExibemotoristaterminal(value?.exibemotoristaterminal);
                  } else {
                    setExibemotoristaterminal(0);
                  }
                  if (value?.diasliberadigitacaomovimentacaobico) {
                    setDiasliberadigitacaomovimentacaobico(
                      value?.diasliberadigitacaomovimentacaobico
                    );
                  } else {
                    setDiasliberadigitacaomovimentacaobico(0);
                  }

                  // console.log(JSON.stringify(value))
                }}
                onLoadingChange={handleAsyncLoadingChange}
                onLoadingError={handleAsyncLoadingError}
              />
            )}

            {create ? (
              posto && Number(diasliberadigitacaomovimentacaobico) > 0 ? (
                <>
                  <DateTime
                    time
                    name="datahorainicialmovimentacao"
                    disabled={!create}
                    label={t(
                      's.operacao.abastecimento.datahorainicialmovimentacao'
                    )}
                    minDate={moment().subtract(
                      Number(diasliberadigitacaomovimentacaobico),
                      'days'
                    )} // ex: permite no máximo 7 dias atrás
                    maxDate={moment()}
                    shouldDisableDate={(day) =>
                      day.isBefore(
                        moment().subtract(
                          Number(diasliberadigitacaomovimentacaobico),
                          'days'
                        )
                      )
                    }
                    disableMaskedInput
                    helperText=""
                  />
                  <DateTime
                    time
                    name="datahorafinalmovimentacao"
                    disabled={!create}
                    label={t(
                      's.operacao.abastecimento.datahorafinalmovimentacao'
                    )}
                    minDate={moment().subtract(
                      Number(diasliberadigitacaomovimentacaobico),
                      'days'
                    )} // ex: permite no máximo 7 dias atrás
                    maxDate={moment()}
                    shouldDisableDate={(day) =>
                      day.isBefore(
                        moment().subtract(
                          Number(diasliberadigitacaomovimentacaobico),
                          'days'
                        )
                      )
                    }
                    disableMaskedInput
                    helperText=""
                  />
                </>
              ) : (
                <></>
              )
            ) : (
              <>
                <DateTime
                  time
                  name="datahorainicialmovimentacao"
                  disabled={!create}
                  label={t(
                    's.operacao.abastecimento.datahorainicialmovimentacao'
                  )}
                />
                <DateTime
                  time
                  name="datahorafinalmovimentacao"
                  disabled={!create}
                  label={t(
                    's.operacao.abastecimento.datahorafinalmovimentacao'
                  )}
                />
              </>
            )}

            <Input
              name="idveiculo"
              disabled={!habCodigoVeiculo}
              onInputChange={(event, newValue) => {
                setVeiculo(newValue);
              }}
              onChange={(event) => setVeiculo(event.target.value)}
              label={
                !can(TRR_CHILE)
                  ? t('s.operacao.abastecimento.idveiculo')
                  : t('s.cadastro.codigoempresacliente')
              }
              onKeyUp={({ key }) =>
                key === 'Enter' && handleValidateInputVehicle()
              }
              getValue={(value) => setVeiculo(value)}
              onBlur={() => handleValidateInputVehicle()}
            />

            {
              habTrocaParaEmpresaAtual && (
                <>
                  <Checkbox
                    name="trocaparaempresaatual"
                    label={t('s.operacao.abastecimento.trocaparaempresaatual')}
                    checked={false}
                    getValue={(value) => {
                      // console.log(JSON.stringify(value))
                      setTrocaparaempresaatual(value);
                    }}
                  />

                  <Input
                    name="empresaAtualNomeVeiculo"
                    // label={t('Empresa atual:')}
                    value={empresaAtualNomeVeiculo}
                    disabled
                  />
                  <br />
                  <br />
                </>
              )
              // const [empresaAtualNomeVeiculo, setEmpresaAtualNomeVeiculo] = useState(null);
              // const [empresaAtualCodigoVeiculo, setEmpresaAtualCodigoVeiculo] = useState(null);
            }

            {/* //{JSON.stringify()} */}

            <Input
              name="idempresaveiculo"
              label={
                !can(TRR_CHILE)
                  ? t('s.operacao.abastecimento.nomeempresaveiculo')
                  : t('s.cadastro.nomeempresacliente')
              }
              value={empresaVeiculo}
              disabled
            />

            {can(CENTRO_CUSTO_ABASTECIMENTO) && (
              <Input
                name="idcentrocusto"
                disabled={!habCodigoCentroCusto}
                label={t('s.operacao.abastecimento.idcentrocusto')}
                value={custo}
                getValue={(value) => setCusto(value)}
                onInputChange={(event, newValue) => {
                  setCusto(newValue);
                }}
                onBlur={handleValidateCenterCost}
              />
            )}

            {can(OPERACAO_ABASTECIMENTO) && (
              <Select
                name="idoperacao"
                label={t(
                  's.geral.camposistema.operacaomovimentacaoabastecimento'
                )}
                data={optionsOper}
                disabled={isNull(veiculo)}
              />
            )}

            {can(LOCALIDADE_ABASTECIMENTO) && (
              <Autocomplete
                name="idlocalidade"
                label="nomelocalidade"
                url="localidades"
                unique="idlocalidade"
                title="Localidade"
                disabled={create && Number(localidadeFixa) > 0}
                forcedValue={
                  create && Number(localidadeFixa) > 0
                    ? localidadeFixa
                    : undefined
                }
                onLoadingChange={handleAsyncLoadingChange}
                onLoadingError={handleAsyncLoadingError}
              />
            )}

            {can(SAFRA_ABASTECIMENTO) && (
              <Autocomplete
                name="idsafra"
                title={t('s.geral.camposistema.idsafra')}
                url="safras"
                unique="idsafra"
                label="descricaosafra"
                onLoadingChange={handleAsyncLoadingChange}
                onLoadingError={handleAsyncLoadingError}
              />
            )}

            <Input
              name="totalizadormovimentacaoabastecimento"
              type="number"
              disabled={!habTotalizador}
              label={t(
                `s.operacao.abastecimento.${totalizador === 1 ? 'horimetro' : 'hodometro'
                }`
              )}
              style={{
                display: includes([1, 2], totalizador) ? 'block' : 'none',
              }}
            />

            {habTotalizador2 && (
              <Input
                name="totalizador2movimentacaoabastecimento"
                type="number"
                disabled={!habTotalizador2}
                label={t(
                  `s.operacao.abastecimento.${totalizador2 === 1 ? 'horimetro' : 'hodometro'
                  }`
                )}
                style={{
                  display: includes([1, 2], totalizador2) ? 'block' : 'none',
                }}
              />
            )}

            <Input
              name="encerranteinicialmovimentacao"
              disabled={!create && !canURL().altera_encerrante}
              label={t(
                's.operacao.abastecimento.encerranteinicialmovimentacao'
              )}
              type="number"
            />

            <Input
              name="encerrantefinalmovimentacao"
              disabled={!create && !canURL().altera_encerrante}
              label={t('s.operacao.abastecimento.encerrantefinalmovimentacao')}
              type="number"
            />

            <Input
              name="volumemovimentacao"
              disabled={!create}
              label={t('s.operacao.abastecimento.volumemovimentacao')}
              type="number"
            />

            {((!can(CUSTOMIZACAO_RAIZEN) &&
              can(MOTORISTA_ABASTECIMENTO) &&
              exibeCampoMotorista) ||
              (can(CUSTOMIZACAO_RAIZEN) &&
                can(MOTORISTA_ABASTECIMENTO) &&
                exibeCampoMotorista)) && (
                // {can(MOTORISTA_ABASTECIMENTO) && (exibeCampoMotorista) && (
                // {can(MOTORISTA_ABASTECIMENTO) && (exibemotoristaterminal > 0) && (
                <Input
                  name="idmotorista"
                  disabled={!habMotorista}
                  label={t('s.operacao.abastecimento.idmotorista')}
                  value={motorista}
                  getValue={(value) => setMotorista(value)}
                  onBlur={() => handleValidateMotorista()}
                  onKeyUp={({ key }) =>
                    key === 'Enter' && handleValidateMotorista()
                  }
                />
              )}

            {/*
          {(!can(CUSTOMIZACAO_RAIZEN) && can(MOTORISTA_ABASTECIMENTO))
            || (can(CUSTOMIZACAO_RAIZEN) && can(MOTORISTA_ABASTECIMENTO) && (exibeCampoMotorista)) && (
              // {can(MOTORISTA_ABASTECIMENTO) && (exibeCampoMotorista) && (
              // {can(MOTORISTA_ABASTECIMENTO) && (exibemotoristaterminal > 0) && (
              <Input
                name="idmotorista"
                disabled={!habMotorista}
                label={t('s.operacao.abastecimento.idmotorista')}
                value={motorista}
                getValue={(value) => setMotorista(value)}
                onBlur={() => handleValidateMotorista()}
                onKeyUp={({ key }) =>
                  key === 'Enter' && handleValidateMotorista()
                }
              />
            )} */}

            {formaidfrentistaabast !== 0 && (
              <Input
                name="codigousuario"
                disabled={!habCodigoUsuario}
                label={t('s.operacao.abastecimento.codigousuario')}
              />
            )}

            {can(MODULO_20_GRAUS) &&
              controla20graus === 1 &&
              operabastecimento20posto === 1 &&
              create && (
                <InputText
                  name="temperaturamediamovimentacao"
                  label={t('s.operacao.abastecimento.temperaturamedia')}
                  mask="99,9"
                  placeholder=""
                  getValue={(value) => {
                    if (value) {
                      let val = String(value);
                      val = val.replace(',', '.');

                      setTemperaturamedia(Number(val));
                    }
                  }}
                />
              )}

            {can(MODULO_20_GRAUS) &&
              controla20graus === 1 &&
              operabastecimento20posto === 1 &&
              !create && (
                <>
                  <Input
                    name="temperaturamediamovimentacao"
                    type="number"
                    disabled
                    label={t('s.operacao.abastecimento.temperaturamedia')}
                  // placeholder=""
                  // getValue={(value) => setTemperaturamedia(Number(value))}
                  />
                  <Input
                    name="densidade20movimentacao"
                    type="number"
                    disabled
                    label={t('s.operacao.abastecimento.densidade20')}
                  // placeholder=""
                  // getValue={(value) => setDensidade20(Number(value))}
                  />
                  <Input
                    name="volume20movimentacao"
                    type="number"
                    disabled
                    label={t('s.operacao.abastecimento.volume20movimentacao')}
                  // placeholder=""
                  // getValue={(value) => setVolume20(Number(value))}
                  />
                </>
              )}

            {
              can(MODULO_FERROVIA) && can(MODULO_CUSTOMIZACAO_VLI) && (
                <InputSlider
                  name="percentualtanquemovimentacaoabastecimento"
                  label={t(
                    's.operacao.abastecimento.percentualtanquemovimentacaoabastecimento'
                  )}
                  width="300px"
                  inputWidth="70px"
                  labelSize="12px"
                  labelVariant="caption"
                  // showIcon={false}
                  icon={TuneIcon}
                  disabled={!habPercentualTanqueFinal}
                />
              )
              // <InputSlider
              //   name="percentualtanquemovimentacaoabastecimento"
              //   label={t('s.operacao.abastecimento.percentualtanquemovimentacaoabastecimento')}
              //   width="300px"
              //   inputWidth="70px"
              //   disabled={!habPercentualTanqueFinal}
              // />
            }
          </Form>
          <Spinner loading={pendingRequests > 0} />
        </div>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
  toggleLoading: PropTypes.func,
  toggleConfirmButton: PropTypes.func,
};

CreateOrUpdate.defaultProps = {
  data: {},
  toggleLoading: () => { },
  toggleConfirmButton: () => { },
};
